import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/store';
import Tooltip from './Tooltip';
import '../../sass/components/_backtesting.scss';

const Backtesting = () => {
    const { backtesting } = useStores();
    const { isOpen, toggle } = backtesting;

    return (
        <div className={classNames('ciq-menu ciq-enabled sc-backtesting-menu')}>
            <Tooltip
                className='sc-backtesting-menu__tooltip'
                enabled
                content={t.translate('Backtesting')}
            >
                <div 
                    className={classNames('cq-menu-btn sc-backtesting__menu', { 
                        'sc-backtesting__menu--active': isOpen 
                    })}
                    onClick={toggle}
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M6 2V4H14V2H16V4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V6C0 5.46957 0.210714 4.96086 0.585786 4.58579C0.960859 4.21071 1.46957 4 2 4H4V2H6ZM2 8V18H18V8H2ZM10 10L13 13L10 16V14H6V12H10V10Z"/>
                    </svg>
                </div>
            </Tooltip>
        </div>
    );
};

export default observer(Backtesting);
